module.exports = __webpack_public_path__ + "static/media/dashsentry-2.18184c18.jpg";